import { StatefulCallClient, StatefulChatClient } from "@azure/communication-react";
import { createStore, Mutate, StoreApi } from "zustand";
import { immer } from "zustand/middleware/immer";
import { createChatThreadSlice } from "./slices/chatThreadStateSlice";
import { PcpLiveLessonState } from "./pcpLiveLessonStore.interface";
import { createStatefulClientsSliceWithProps } from "./slices/statefulClientsSlice";
import { CreatePcpSharedContextProps, createPcpSharedSlice } from "./slices/pcpSharedSlice";


export const createPcpLiveLessonStore = (
    callClient: StatefulCallClient,
    chatClient: StatefulChatClient,
    sharedProps: CreatePcpSharedContextProps
): StoreApi<PcpLiveLessonState> => createStore<PcpLiveLessonState>()(
    immer((...args) => ({
        // ...createStatefulClientsSlice(...args),
        ...createStatefulClientsSliceWithProps(callClient, chatClient)(...args),
        ...createChatThreadSlice(...args),
        ...createPcpSharedSlice(sharedProps)(...args),
    })),
) as StoreApi<PcpLiveLessonState>;

export type PcpLiveLessonStore = ReturnType<typeof createPcpLiveLessonStore>;
